"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var WarningRounded_1 = __importDefault(require("@mui/icons-material/WarningRounded"));
var Button_1 = __importDefault(require("../../button/Button"));
/**
 * @component DeleteModal
 * @example
 * return (
 *  <DatePicker
 *     className= {className}
 *     mask="__/__/____"
 *     label={label}
 *     value={value}
 *     minDate={minDate}
 *     maxDate={maxDate}
 *     onChange={onChange}
 *     disabled={disabled}
 *     shouldDisableDate={disableDays}
 *     renderInput={(params) => <TextField {...params} />}
 *   />
 * )
 * @param {boolean} open
 * @param {string} title
 * @param {string} subTitle
 * @param {string} okButtonText
 * @param {function} handleDeleteCancel
 * @param {function} handleDeleteOk
 */
function DeleteModal(props) {
    var open = props.open, title = props.title, subTitle = props.subTitle, okButtonText = props.okButtonText, handleDeleteCancel = props.handleDeleteCancel, handleDeleteOk = props.handleDeleteOk;
    return (react_1.default.createElement(material_1.Dialog, { className: "modal delete-modal", scroll: "body", open: open, fullWidth: true, maxWidth: "md" },
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.Grid, { container: true, direction: "column", alignItems: "center" },
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true, className: "mb-4 mt-2" },
                    react_1.default.createElement(WarningRounded_1.default, { color: "error" })),
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true, className: "mb-2" },
                    react_1.default.createElement(material_1.Typography, { variant: "subtitle1" }, title)),
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true },
                    react_1.default.createElement(material_1.Typography, { variant: "body1" }, subTitle)))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { onClick: handleDeleteCancel, type: "secondary" }, "Cancel"),
            react_1.default.createElement(Button_1.default, { type: "danger", onClick: handleDeleteOk, marginLeft: 0 }, okButtonText))));
}
exports.default = DeleteModal;
